<template>
  <div class="quick-answer mt-2 mb-2 ml-2">
    <div v-if="loading" class="quick-answer-loading">
      <loading />
    </div>
    <b-button-group v-else>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-primary"
        @click="emitSendMessage({ message: labels.thanksFeedback })"
      >
        {{ labels.thanksFeedback }}
      </b-button>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-primary"
        @click="emitSendMessage({ message: '👍' })"
      >
        <span class="emoji">👍</span>
      </b-button>
      <b-button
        size="sm"
        variant="outline-primary"
        @click="emitSendMessage({ message: '💓' })"
      >
        <span class="emoji">💓</span>
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/Shared/Loading.vue'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels: function() {
      return this.resources.page.home.feedbacks.tickets.quickAnswer
    },
  },
  methods: {
    emitSendMessage({ message }) {
      this.loading = true
      this.$emit('sendMessage', {
        message,
        isAnonymous: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.quick-answer {
  .quick-answer-loading {
    text-align: center;
    height: 40px;
    .lds-ellipsis {
      div {
        top: 15px !important;
      }
    }
  }

  button {
    height: 45px !important;
    text-transform: inherit !important;
    border-color: map-get($theme-colors, 'white');
    &:hover {
      background-color: white;
      color: map-get($theme-colors, 'primary');
      border-color: map-get($theme-colors, 'primary');
    }
  }

  .emoji {
    font-size: 18pt;
  }
}
</style>
